{
  "title": "إيداع أمانة",
  "description": "أدخل المبلغ والعملة ثم أرسل النموذج إلى التابلت ليكمله المودع ويوقع.",
  "form": {
    "title": "بيانات الأمانة",
    "chooseCurrency": "اختر العملة",
    "decimalsHint": "حتى خمس منازل عشرية",
    "tabletRequired": "اختر جهاز التابلت",
    "voidsSignature": "تغيير المبلغ أو العملة يلغي توقيع المودع ويعيد النموذج إلى التابلت.",
    "customerNotPresent": "العميل غير موجود",
    "customerNotPresentHint": "لن يرسل شيء إلى التابلت، وتحفظ العملية بدون بيانات العميل وتوقيعه",
    "saveDraft": "حفظ المسودة"
  },
  "waiting": {
    "summary": "ملخص الأمانة",
    "tabletTitle": "التابلت",
    "onTablet": "النموذج معروض على التابلت. بانتظار المودع.",
    "tabletOffline": "التابلت غير متصل. تأكد من تشغيله ثم أعد الإرسال.",
    "liveReconnecting": "انقطع الاتصال المباشر. جاري إعادة الاتصال...",
    "signatureVoided": "تم إلغاء التوقيع السابق وأعيد النموذج إلى التابلت.",
    "resent": "تم إرسال النموذج إلى التابلت"
  },
  "review": {
    "language": "لغة المودع",
    "languageName": {
      "ar": "العربية",
      "en": "الإنجليزية"
    },
    "noSignature": "لم يوقع المودع",
    "checkCash": "تحقق من النقد والبيانات قبل تأكيد الإيداع.",
    "customerNotPresent": "تحفظ الأمانة بدون بيانات المودع وتوقيعه."
  },
  "confirm": {
    "statement": "تأكيد استلام النقد من المودع"
  },
  "result": {
    "title": "تم إيداع الأمانة بنجاح",
    "description": "اطبع الوصل وسلمه للمودع.",
    "messages": "رسائل واتساب",
    "noMessages": "لا توجد رسائل لهذه الأمانة",
    "role": {
      "DEPOSITOR": "المودع",
      "INTENDED_RECIPIENT": "المستلم المقصود",
      "ACTUAL_RECIPIENT": "المستلم الفعلي"
    }
  },
  "discard": {
    "action": "حذف المسودة",
    "title": "حذف المسودة؟",
    "description": "ستحذف بيانات هذه الأمانة غير المؤكدة ويعود التابلت إلى الشاشة الرئيسية.",
    "done": "تم حذف المسودة بنجاح"
  }
}
